const LOCAL_TOKEN_KEY = "starlive_token"
const SESSION_TOKEN_KEY = "starlive_session_token"
const LEGACY_LOCAL_TOKEN_KEY = "liveframe_token"
const LEGACY_SESSION_TOKEN_KEY = "liveframe_session_token"

function migrateLegacyToken(storage, currentKey, legacyKey) {
  const currentToken = storage.getItem(currentKey)
  if (currentToken) return currentToken

  const legacyToken = storage.getItem(legacyKey)
  if (!legacyToken) return ""

  // 品牌升级时迁移已有会话，避免已登录用户被无故退出。
  storage.setItem(currentKey, legacyToken)
  storage.removeItem(legacyKey)
  return legacyToken
}

export function getAuthToken() {
  // 当前标签页会话优先，其次读取勾选“保持登录”后保存的长期令牌。
  return migrateLegacyToken(sessionStorage, SESSION_TOKEN_KEY, LEGACY_SESSION_TOKEN_KEY)
    || migrateLegacyToken(localStorage, LOCAL_TOKEN_KEY, LEGACY_LOCAL_TOKEN_KEY)
}

export function setAuthToken(token, remember) {
  // 每次登录只保留一种存储位置，避免旧令牌覆盖新登录状态。
  clearAuthToken()
  if (remember) {
    localStorage.setItem(LOCAL_TOKEN_KEY, token)
  } else {
    sessionStorage.setItem(SESSION_TOKEN_KEY, token)
  }
}

export function clearAuthToken() {
  localStorage.removeItem(LOCAL_TOKEN_KEY)
  localStorage.removeItem(LEGACY_LOCAL_TOKEN_KEY)
  sessionStorage.removeItem(SESSION_TOKEN_KEY)
  sessionStorage.removeItem(LEGACY_SESSION_TOKEN_KEY)
}
